import { render, staticRenderFns } from "./ShowMessage.vue?vue&type=template&id=49926882&scoped=true&"
import script from "./ShowMessage.vue?vue&type=script&lang=js&"
export * from "./ShowMessage.vue?vue&type=script&lang=js&"
import style0 from "./ShowMessage.vue?vue&type=style&index=0&id=49926882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49926882",
  null
  
)

export default component.exports